import { render, staticRenderFns } from "./leavingRequests.vue?vue&type=template&id=880d260e&scoped=true&"
import script from "./leavingRequests.vue?vue&type=script&lang=js&"
export * from "./leavingRequests.vue?vue&type=script&lang=js&"
import style0 from "./leavingRequests.vue?vue&type=style&index=0&id=880d260e&lang=scss&scoped=true&"
import style1 from "./leavingRequests.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880d260e",
  null
  
)

export default component.exports